import { ADD_ON_IDS } from './constants';
import type { AddOnsResponseAddOn } from '../../repositories';
import { PriceVO } from '../price';

type AddOnPriceTier = Omit<AddOnsResponseAddOn['priceTiers'][number], 'price'> & {
  price: PriceVO;
};

export class AddOn {
  public readonly priceTiers: AddOnPriceTier[];

  constructor(private readonly values: AddOnsResponseAddOn) {
    this.priceTiers = values.priceTiers.map((tier) => ({
      ...tier,
      price: new PriceVO(tier.price),
    }));
  }

  public getPurchased() {
    return this.values.purchased;
  }

  public getId() {
    return this.values.id;
  }

  public getIsSmsAddOn() {
    return this.getId() === ADD_ON_IDS.SMS;
  }
}
